import { Injectable, inject } from '@angular/core';

import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { TableStateModel } from '../../models/table-state.model';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { DbContext } from '../../core/utils/db-context';

@Injectable({
    providedIn: 'root'
})
export class TableStateRepository extends BaseEntityRepository<TableStateModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);

        this.config = RepositoriesConfig.repositories.find(r =>
            r.tableName === DbContext.TablesStates
        );
        this.skipLocalUpdate = true;
    }
}
